import React, { useEffect } from 'react';
import type { ViewProps } from 'react-native';
import { StyleSheet } from 'react-native';
import { cancelAnimation, useAnimatedStyle, useSharedValue, withRepeat, withTiming } from 'react-native-reanimated';
import { AnimationContext } from './context';

export interface ShineProps extends ViewProps {
  /* Animation duration, default is 750 */
  duration?: number;

  /* Play the animation in reverse mod */
  reverse: boolean;
}

export function Shine({ duration, children, style, reverse }: ShineProps) {
  const start: `${number}%` = reverse ? '100%' : '0%';
  const end: `${number}%` = reverse ? '0%' : '100%';
  const animation = useSharedValue(start);

  useEffect(() => {
    animation.set(start);
    animation.set(withRepeat(withTiming(end, { duration: duration || 750 }), -1));
    return () => {
      cancelAnimation(animation);
    };
  }, [animation, duration, end, start]);

  const animatedStyle = useAnimatedStyle(() => ({ left: animation.get() }));

  return <AnimationContext.Provider value={[styles.shine, animatedStyle, style]}>{children}</AnimationContext.Provider>;
}

const styles = StyleSheet.create({
  shine: {
    backgroundColor: 'white',
    height: '100%',
    opacity: 0.5,
    width: '40%',
  },
});
